export default __webpack_public_path__ + "static/liferay-464908035246f181d691457af7e5b167.webm";